import { Button } from "@/components/ui/button"
import { Calendar, Search, X } from "lucide-react"
import { useState } from "react"
import { Input } from "@/components/ui/input"

interface ActivityFiltersProps {
  timeFilter: 'all' | 'today' | 'week' | 'month'
  searchQuery: string
  onTimeFilterChange: (value: 'all' | 'today' | 'week' | 'month') => void
  onSearchChange: (value: string) => void
}

export function ActivityFilters({
  timeFilter,
  searchQuery,
  onTimeFilterChange,
  onSearchChange
}: ActivityFiltersProps) {
  return (
    <div className="space-y-4">
      {/* Search bar - always visible */}
      <div className="relative">
        <div className="relative">
          <Search className="absolute left-2 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            type="text"
            placeholder="Search activities..."
            className="w-full pl-8 py-2 h-9"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          {searchQuery && (
            <Button
              variant="ghost"
              size="sm"
              className="absolute right-1 top-1/2 h-6 w-6 -translate-y-1/2 p-0"
              onClick={() => onSearchChange("")}
            >
              <X className="h-4 w-4" />
            </Button>
          )}
        </div>
      </div>

      {/* Time Filter */}
      <div className="flex flex-wrap gap-2">
        <Button
          variant={timeFilter === 'all' ? "default" : "outline"}
          size="sm"
          onClick={() => onTimeFilterChange('all')}
          className="h-8"
        >
          All Time
        </Button>
        <Button
          variant={timeFilter === 'today' ? "default" : "outline"}
          size="sm"
          onClick={() => onTimeFilterChange('today')}
          className="h-8"
        >
          <Calendar className="mr-1 h-4 w-4" />
          Today
        </Button>
        <Button
          variant={timeFilter === 'week' ? "default" : "outline"}
          size="sm"
          onClick={() => onTimeFilterChange('week')}
          className="h-8"
        >
          <Calendar className="mr-1 h-4 w-4" />
          This Week
        </Button>
        <Button
          variant={timeFilter === 'month' ? "default" : "outline"}
          size="sm"
          onClick={() => onTimeFilterChange('month')}
          className="h-8"
        >
          <Calendar className="mr-1 h-4 w-4" />
          This Month
        </Button>
      </div>
    </div>
  )
}
